<template>
  <div class="boxbgcolor">
    <div class="content-left">
      <GatewayTree ref="areaTree" :moduleName="moduleName" v-on:handleTreeClick="handleTreeClick"></GatewayTree>
    </div>
    <div class="right content-right">
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for="a_name">设备编号</label>
            <input
              v-model="search.stationSn"
              class="form-control"
              id="a_name"
              type="text"
              placeholder
              size="12"
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button @click="searchList" type="button" class="btn btn-primary" id="search_btn">查询</button>
            </span>
            <!--<button @click="clearSearch" type="button" class="btn btn-default">清空</button>-->
            <span class="add_btn">
              <button
                v-if="stationManger_btn_add"
                type="button"
                class="btn btn-default"
                id="addarea"
                @click="addrOrEdit()"
              >添加</button>
            </span>

            <span class="refresh_btn">
              <Refresh @tableList="this.tableList"></Refresh>
            </span>
          </div>
        </form>
      </div>

      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData.rows"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column label="设备编号" prop="stationSn"></el-table-column>
          <el-table-column label="设备名称" prop="name"></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">{{scope.row.stationStatus=='normal'?'正常':'异常'}}</template>
          </el-table-column>
          <el-table-column label="终端数量" prop="attr1"></el-table-column>
          <el-table-column label="心跳周期">
            <template slot-scope="scope">{{scope.row.geomagBhPeriod}}秒</template>
          </el-table-column>
          <el-table-column label="通信频率" prop="loraID"></el-table-column>
          <el-table-column label="剩余电量(%)">
            <template slot-scope="scope">
              <div class="electricity">
                <div class="battery">
                  <canvas width="20" height="10" :id="scope.row.stationId" class="show_pow"></canvas>
                  <canvas width="5" height="5" :id="scope.row.stationId+'s'" class="pow_head"></canvas>
                </div>
                <div>{{(!scope.row.attr3)||scope.row.attr3=='null'?0:scope.row.attr3}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="最后通讯时间" prop="lastFlowDate"></el-table-column>
          <el-table-column label="下发设备">
            <template slot-scope="scope">
              <div class="lowerEquip">
                <button @click="lowerEquip(scope.row.stationId)" class="lowerEquipButton">下发设备</button>
                <span class="statusBg">
                  <span
                    v-if="(scope.row.successNum==0&&scope.row.totalNum!=0)||scope.row.successNum==0&&scope.row.totalNum==0||scope.row.successNum>scope.row.totalNum"
                    class="fail"
                  ></span>
                  <span
                    v-if="(scope.row.successNum==scope.row.totalNum)&&scope.row.successNum!=0&&scope.row.totalNum!=0"
                    class="success"
                  ></span>
                  <span
                    v-if="scope.row.successNum<scope.row.totalNum&&scope.row.successNum!=0"
                    class="someSuccess"
                  >{{scope.row.currentNum}}</span>
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200px">
            <template slot-scope="scope">
              <button
                class="chargingRules"
                type="button"
                v-if="stationManger_btn_heart"
                @click="setHeartTime(scope.row.stationId)"
              >心跳周期</button>
              <button
                class="edit"
                v-if="stationManger_btn_edit"
                type="button"
                @click="addrOrEdit(scope.row.stationId)"
              >修改</button>
              <button
                class="delete"
                v-if="stationManger_btn_remove"
                @click="del(scope.row.stationId)"
                type="button"
              >删除</button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- <Page :pageSize="search.pageSize"></Page> -->
    <Page v-on:pagination="receivePaginationData"></Page>

    <!-- 添加/修改设备 -->
    <el-dialog
      title="添加/修改设备"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="dialogFormVisible"
      width="500px"
      @open="openDialog"
      @close="closeDialog"
    >
      <div class="clearfix">
        <el-form
          class="fl"
          style="width:100%;"
          ref="form"
          label-position="right"
          :model="form"
          :rules="rules"
          :label-width="formLabelWidth"
          id="form"
        >
          <el-form-item label="编号" prop="stationSn">
            <el-col :span="18">
              <el-input v-model="form.stationSn"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="名称" prop="stationName">
            <el-col :span="18">
              <el-input v-model="form.stationName"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="通信频率" prop="loraID">
            <el-col :span="18">
              <el-input v-model="form.loraID"></el-input>
            </el-col>
          </el-form-item>
        </el-form>

        <!-- <div class="fr" id="areaMap" style="width: 52%;height: 380px;">
					
        </div>-->
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addrOrEditTrue">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 设置心跳周期 -->
    <el-dialog
      title="心跳周期"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="dialogFormHeartTimeVisible"
      width="500px"
    >
      <div class="clearfix">
        <el-form
          class="fl"
          style="width:100%;"
          ref="cycleForm"
          label-position="right"
          :model="heartTime"
          :rules="rules"
          :label-width="formLabelWidth"
        >
          <el-form-item label="时间">
            <el-col :span="18">
              <el-input v-model="heartTime.timer">
                <template slot="append">秒</template>
              </el-input>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormHeartTimeVisible= false">取 消</el-button>
        <el-button type="primary" @click="setHeartTimeTrue">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import {
  lowerEquip,
  setHeartTime,
  getAllStationList,
  removeStation,
  editStation,
  addStation,
  getStationList,
  getAllParkingsByEnabled,
  getParkSingle,
  parkingBusType,
  dictValue,
  getCity,
  parkList,
  getRulesType,
  addOrUpdateChargeRule,
  getChargeRule,
  parkAdd,
  addMapOverlay,
  addMapOverlayl,
  setMapEvent,
  addMapControl,
  getManagerList,
} from "@/api/url";

import Page from "../../commons/page";

import Paho from "../../../utils/mqttws31";

// import Refresh from "../commons/refresh.vue";

import GatewayTree from "../../commons/gatewayTree";

export default {
  data() {
    return {
      treeData: {
        parentId: "",
      },
      stationManger_btn_remove: false,
      stationManger_btn_add: false,
      stationManger_btn_edit: false,
      stationManger_btn_heart: false,
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      vueMqtt: {
        hostname: "mosquitto.52zhysq.com",
        port: 3001,
        //port:1883,
        timeout: 5,
        keepAlive: 50,
        cleanSession: false,
        useTLS: true,

        userName: "adminpark",
        password: "admin123456",
        topic: "",

        reconnectTimeout: 2000,
        client: null,
        message: null,
      },
      moduleName: "station",
      form: {
        stationId: "",
        stationName: "",
        stationSn: "",
        loraID: "",
      },
      heartTime: {
        timer: "",
        stationId: "",
      },
      search: {
        pageNumber: 1,
        pageSize: 10,
        stationSn: "",
      },
      tableListData: {
        rows: [],
      },
      tableListDataExcel: {},
      tableListDataAll: {},
      downloadFileds: {
        设备编号: "stationSn",
        设备名称: "name",
        状态: {
          field: "stationStatus",
          callback: (value) => {
            return value == "nomal" ? "正常" : "异常";
          },
        },
        终端数量: "attr1",
        心跳周期: {
          field: "geomagBhPeriod",
          callback: (value) => {
            return value + "秒";
          },
        },
        通信频率: "loraID",
        最后通讯时间: "lastFlowDate",
      },
      formLabelWidth: "100px",
      dialogFormVisible: false,
      dialogFormHeartTimeVisible: false,
      rules: {
        stationSn: [
          { required: true, message: "请填写设备编号", trigger: "blur" },
        ],
        stationName: [
          { required: true, message: "请填写设备名称", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    ...mapMutations(["getPage", "storageScenId"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    handleTreeClick(node, data) {
      this.search.stationSn = "";
      if (node.type != "parking") {
        var pageObj = {
          curIndex: 1,
          rowsCount: 0,
        };
        this.getPage(pageObj);
        this.treeData.parentId = "";
        this.tableListData.rows = [];
        // this.$message({
        // 	type:'warning',
        // 	message:'请选择车场'
        // })
        return;
      } else {
        this.treeData.parentId = node.id;
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
      }
    },
    tableListAll: function () {
      this.$get(getAllStationList()).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        this.tableListDataAll = data.data;
      });
    },
    //创建MQTT连接
    MQTTconnect: function () {
      this.vueMqtt.client = new Paho.MQTT.Client(
        this.vueMqtt.hostname,
        this.vueMqtt.port,
        "web_" + parseInt(Math.random() * 100, 10)
      );
      var options = {
        invocationContext: {
          host: this.vueMqtt.hostname,
          port: this.vueMqtt.port,
          path: this.vueMqtt.client.path,
          clientId: "web_" + parseInt(Math.random() * 100, 10),
        },
        timeout: this.vueMqtt.timeout,
        keepAliveInterval: this.vueMqtt.keepAlive,
        cleanSession: this.vueMqtt.cleanSession,
        useSSL: this.vueMqtt.useTLS,
        userName: this.vueMqtt.userName,
        password: this.vueMqtt.password,
        onSuccess: this.onConnect,
        onFailure: this.onFailure,
      };
      // this.vueMqtt.client.onConnectionLost = this.onConnectionLost;

      // this.vueMqtt.client.onMessageArrived = this.onMessageArrived;

      this.vueMqtt.client.connect(options);
    },
    //连接中
    onConnect: function () {
      console.log("网关 Mqtt connected");

      this.vueMqtt.client.subscribe(this.vueMqtt.topic);

      // this.vueMqtt.message = new Paho.MQTT.Message("Hello，i am fron web js.");
      // this.vueMqtt.message.destinationName = "topic/gw";
      // this.vueMqtt.client.send(this.vueMqtt.message);
    },
    //连接失败
    onFailure: function () {
      console.log("error");
      setTimeout(this.MQTTconnect, this.vueMqtt.reconnectTimeout);
    },
    //失去连接
    onConnectionLost: function (responseObject) {
      console.log("重新连接");
      setTimeout(this.MQTTconnect, this.vueMqtt.reconnectTimeout);
    },
    //收到消息
    onMessageArrived: function (message) {
      // console.log("收到消息:")
      //console.log(this.vueMqtt.cleanSession)
      // console.log(message.payloadString);
      this.tableList(this.curIndex);
    },

    //下发设备
    lowerEquip(id) {
      this.$postRequest(lowerEquip() + "?stationId=" + id).then((data) => {
        this.$notify({
          title: "成功",
          message: "操作成功!",
          type: "success",
        });
      });
    },

    tableList: function (curPage) {
      var _this = this;
      this.$get(getStationList(), {
        parkingId: this.treeData.parentId,
        limit: this.search.pageSize,
        page: curPage,
        stationSn: this.search.stationSn,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页

        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData.rows = data.data.rows;
        _this.$nextTick(this.canvasPow);
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      });
    },
    canvasPow() {
      var _this = this;
      for (let item of _this.tableListData.rows) {
        var canvas = document.getElementById(item.stationId);

        var context = canvas.getContext("2d");
        context.clearRect(0, 0, 20, 10);
        var pow = item.attr3 || 0;
        if (pow >= 80) {
          canvas.style = "border:1px solid #696969";
          context.fillStyle = "green";
        } else if (pow >= 40 && pow < 80) {
          canvas.style = "border:1px solid #696969";
          context.fillStyle = "#FF6100";
        } else if (pow < 40 && pow > 0) {
          canvas.style = "border:1px solid red";
          context.fillStyle = "red";
        } else {
          canvas.style = "border:1px solid red";
          context.fillStyle = "";
        }
        context.fillRect(0, 0, (20 / 100) * parseInt(pow), 10);
        var canvas1 = document.getElementById(item.stationId + "s");
        var context1 = canvas1.getContext("2d");
        context1.fillStyle = "#696969";
        context1.fillRect(0, 0, 5, 5);
      }
    },
    openDialog: function () {},
    closeDialog: function () {
      this.$refs["form"].resetFields();
    },
    searchList: function () {
      if (!this.treeData.parentId) {
        this.$message({
          type: "warning",
          message: "请选择道路",
        });
        return;
      }
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.parkName = "";
    },
    addrOrEdit: function (id) {
      this.dialogFormVisible = true;
      if (Boolean(id)) {
        this.$get(addStation() + "/" + id, { stationId: id }).then((data) => {
          if (data.status != 200) return _this.$layer.msg(data.message);
          this.form.stationId = data.data.stationId;
          this.form.stationSn = data.data.stationSn;
          this.form.stationName = data.data.name;
          this.form.loraID = data.data.loraID;
        });
      } else {
        if (!this.treeData.parentId) {
          this.dialogFormVisible = false;
          this.$message({
            type: "warning",
            message: "请选择道路",
          });
          return;
        }
        this.form.stationId = "";
        this.form.stationSn = "";
        this.form.stationName = "";
        this.form.loraID = "";
      }
    },
    addrOrEditTrue: function () {
      var _this = this;

      this.$refs["form"].validate(function (valid, noStri) {
        if (valid) {
          _this.dialogFormVisible = false;

          if (!Boolean(_this.form.stationId)) {
            _this
              .$postRequest(addStation(), {
                parkingId: _this.treeData.parentId,
                stationSn: _this.form.stationSn,
                name: _this.form.stationName,
                loraID: _this.form.loraID,
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "添加成功",
                });
                _this.search.pageNumber = 1;
                _this.tableList(_this.search.pageNumber);
              });
          } else {
            _this
              .$putRequest(editStation(), {
                parkingId: _this.treeData.parentId,
                stationId: _this.form.stationId,
                stationSn: _this.form.stationSn,
                name: _this.form.stationName,
                loraID: _this.form.loraID,
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "修改成功",
                });
                _this.tableList(_this.curIndex);
              });
          }
        }
      });
    },
    setHeartTime(id) {
      this.dialogFormHeartTimeVisible = true;
      this.heartTime.stationId = id;
      this.$get(addStation() + "/" + id, { stationId: id }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        this.heartTime.timer = data.data.geomagBhPeriod;
      });
    },
    setHeartTimeTrue() {
      var _this = this;
      this.dialogFormHeartTimeVisible = false;
      this.$putRequest(
        setHeartTime() +
          "?stationId=" +
          this.heartTime.stationId +
          "&hearTime=" +
          this.heartTime.timer,
        {}
      ).then((data) => {
        if (data.status != 200) return;
        _this.$notify({
          type: "success",
          title: "成功",
          message: "心跳周期设置成功！",
        });
        _this.tableList(_this.curIndex);
      });
    },
    del: function (id) {
      var _this = this;

      var index = _this.$layer.confirm(
        "您确定删除该设备？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);

          _this
            .$deleteRequest(removeStation() + "?stationId=" + id, {})
            .then((data) => {
              if (data.status != 200)
                return _this.$layer.msg("删除失败", { time: 1 });
              _this.tableList(_this.search.pageNumber);
            });
        }
      );
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    ...mapGetters(["elements"]),
    permiss() {
      this.stationManger_btn_add = this.elements["stationManger:btn_add"];
      this.stationManger_btn_remove = this.elements["stationManger:btn_remove"];
      this.stationManger_btn_edit = this.elements["stationManger:btn_edit"];
      this.stationManger_btn_heart = this.elements["stationManger:btn_heart"];
    },
  },
  components: {
    Page,

    // Refresh,
    GatewayTree,
  },
  created: function () {
    this.permiss;
    // this.vueMqtt.topic="topic/webstation/"+this.$route.query.id;
    //this.vueMqtt.topic="topic/webstation/#";
    // this.vueMqtt.topic="topic/webstation/#";
    // this.MQTTconnect();
    // this.vueMqtt.client.onConnectionLost = this.onConnectionLost;
    // this.vueMqtt.client.onMessageArrived = this.onMessageArrived;
  },
  mounted: function () {
    // this.tableList();
    // this.tableListAll();
  },
  destroyed: function () {
    // this.vueMqtt.client.disconnect();
  },
  watch: {
    elements: {
      handler: function (val, oldVal) {
        this.permiss;
      },
      deep: true, //深度
    },
  },
};
</script>

<style scoped>
.table-rule {
  color: #222;
  border-spacing: 0;
  border-collapse: collapse;
}
.table-rule tr td {
  padding: 10px 10px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 14px;
}

.table-rule .money-input,
.table-rule .time-input {
  width: 40px;
  height: 26px;
  border: 1px solid #ccc;
  /* border: 1px solid #02c1af; */
  border-radius: 2px;
  text-align: center;
  color: #222;
  color: #02c1af;
}

.searchbox {
  background: #f9f9fb;

  border-bottom: 10px solid #eff2f7;
}
.table thead {
  background: #f9f9fb;
}
.list {
  width: 100% !important;
  position: relative;
}
.pagbox {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
/* .edit,
.delete,
.chargingRules {
  display: inline-block;
  width: 40px;
  height: 20px;
  background: #278cd8;
  color: white;
  margin-right: 4px;
  font-size: 12px;
  line-height: 20px;
  border-radius: 4px;
} */
.chargingRules {
  width: 60px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.fail,
.success,
.someSuccess {
  display: block;
  border-radius: 4px;
  width: 12px;
  height: 12px;
}
.fail {
  background: red;
  color: red;
}
.success {
  background: green;
  color: green;
}
.someSuccess {
  background: #ff6100;
  /* width:16px;
	height:16px; */
  line-height: 12px;
  color: white;
  font-size: 8px;
}
.lowerEquip {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.lowerEquipButton {
  width: 60px;
  font-size: 12px;
  background: #409eff;
  color: white;
  height: 20px;
  line-height: 20px;
  /* margin-right:5px; */
}
.refresh {
  display: inline-block !important;
}
.pow {
  text-align: left !important;
  padding-left: 1% !important;
}
.show_pow {
  border: 1px solid #696969;
  border-radius: 2px;
}
.pow_head {
  border-radius: 1px;
}
.battery {
  width: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
.electricity {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>